import NBType, { InferType } from '@netbase/nb-type'

const UserGroupSchema = NBType.object().shape('UserGroupSchema', {
  /* @prop */
  accountProfileId: NBType.number(),
  /* @prop */
  createInstant: NBType.timestamp(),
  /* @prop */
  name: NBType.string(),
  /* @prop */
  userGroupId: NBType.number()
  /* END */
})
export default UserGroupSchema
export type UserGroup = InferType<typeof UserGroupSchema>
// RESERVE BELOW
